module.exports = __webpack_public_path__ + "img/collection-engagementRingsCharacter@2x.f0ca878.webp";